<template>
  <div class="container">
    <HeadingOne class="-margin-md">審査状況のご確認</HeadingOne>

    <!--※未入会者（収入証明書要提出者）の場合-->
    <template v-if="state === '0'">
      <section>
        <NoticeBox class="-point">
          <NoticeHeader>
            <h3 class="heading">収入証明書のご提出をお願いいたします。</h3>
          </NoticeHeader>
          <NoticeBody>
            <ListGroup>
              <ListItem
                >このたびは、au PAY
                スマートローンにお申し込みいただき、誠にありがとうございます。</ListItem
              >
              <ListItem
                >現在審査中となりますが、審査にあたり、収入証明書のご提出が必要となります。</ListItem
              >
              <ListItem
                >収入証明書をお手元にご用意のうえ、以下より書類の提出をお願いいたします。</ListItem
              >
            </ListGroup>
            <p>
              <small
                >※ご提出いただいたご本人さま確認書類の内容ならびに他社の借入状況等により、ご希望に添えない場合がございます。あらかじめご了承ください。</small
              >
            </p>
          </NoticeBody>
        </NoticeBox>
        <BtngroupSingle class="-margin-lg">
          <BtnMain class="-main" router-name="en017"
            >収入証明書のご提出へ</BtnMain
          >
        </BtngroupSingle>
      </section>
    </template>

    <!--※未入会者（本人確認書類再提出者）の場合-->
    <template v-else-if="state === '1'">
      <section>
        <NoticeBox class="-point">
          <NoticeHeader>
            <h3 class="heading">
              ご本人さま確認書類のご提出をお願いいたします。
            </h3>
          </NoticeHeader>
          <NoticeBody>
            <ListGroup>
              <ListItem
                >このたびは、au PAY
                スマートローンにお申し込みいただき、誠にありがとうございます。</ListItem
              >
              <ListItem
                >現在審査中となりますが、ご提出いただいた書類に画像データの不鮮明などの不備があり再度ご提出いただく必要がございます。</ListItem
              >
              <ListItem
                >ご本人さま確認書類をお手元にご用意のうえ、以下より書類の提出をお願いいたします。</ListItem
              >
            </ListGroup>
            <p>
              <small
                >※ご提出いただいたご本人さま確認書類の内容ならびに他社の借入状況等により、ご希望に添えない場合がございます。あらかじめご了承ください。</small
              >
            </p>
          </NoticeBody>
        </NoticeBox>
        <BtngroupSingle class="-margin-lg">
          <BtnMain class="-main" router-name="en026"
            >ご本人さま確認書類のご提出へ</BtnMain
          >
        </BtngroupSingle>
      </section>
    </template>

    <!--※未入会者（本人確認書類再提出、収入証明書）の場合-->
    <template v-else-if="state === '2'">
      <section>
        <NoticeBox class="-point _mb-sm-40 _mb-md-60">
          <NoticeHeader>
            <h2 class="heading">
              ご本人さま確認書類、収入証明書のご提出をお願いいたします。
            </h2>
          </NoticeHeader>
          <NoticeBody>
            <ListGroup>
              <ListItem
                >このたびは、au PAY
                スマートローンにお申し込みいただき、誠にありがとうございます。</ListItem
              >
              <ListItem
                >現在審査中となりますが、ご提出いただいた書類に画像データの不鮮明などの不備があり、再度ご提出いただく必要がございます。また、審査にあたり、収入証明書のご提出も必要となります。</ListItem
              >
              <ListItem
                >お手元にご用意のうえ、書類の提出をお願いいたします。</ListItem
              >
            </ListGroup>
            <p>
              <small
                >※ご提出いただいたご本人さま確認書類の内容ならびに他社の借入状況等により、ご希望に添えない場合がございます。あらかじめご了承ください。</small
              >
            </p>
          </NoticeBody>
        </NoticeBox>

        <BtngroupSingle class="_mb-sm-40">
          <BtnMain class="-main" router-name="en026">
            ご本人さま確認書類のご提出へ
          </BtnMain>
        </BtngroupSingle>

        <BtngroupSingle class="-margin-lg">
          <BtnMain class="-main" router-name="en017">
            収入証明書のご提出へ
          </BtnMain>
        </BtngroupSingle>
      </section>
    </template>

    <template v-else>
      <section>
        <CardBox>
          <CardHeader>
            <h2 class="heading">現在審査中となります。</h2>
          </CardHeader>
          <CardBody>
            <ListGroup>
              <ListItem
                >このたびは、au PAY
                スマートローンにお申し込みいただき、誠にありがとうございます。</ListItem
              >
              <ListItem
                >審査完了後ご登録いただいたメールアドレス宛にご連絡いたします。いましばらくお待ちください。</ListItem
              >
            </ListGroup>
          </CardBody>
        </CardBox>
        <BtngroupSingle class="-margin-lg">
          <BtnMain class="-normal -lg" router-name="sv001"
            >au PAY スマートローントップへ</BtnMain
          >
        </BtngroupSingle>
      </section>
    </template>
  </div>
  <!-- container -->
</template>

<script>
import { setMeta } from "@/utils/Meta";
import { goToErrorPage } from "@/utils/Other";
import { getUserDataLambdaInvoke } from "@/utils/LambdaHelper";
import HeadingOne from "@/components/heading/HeadingOne";
import NoticeBox from "@/components/box/NoticeBox";
import NoticeHeader from "@/components/box/NoticeHeader";
import NoticeBody from "@/components/box/NoticeBody";
import ListGroup from "@/components/list/ListGroup";
import ListItem from "@/components/list/ListItem";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";
import CardBox from "@/components/card/CardBox";
import CardHeader from "@/components/card/CardHeader";
import CardBody from "@/components/card/CardBody";
export default {
  name: "En022",
  components: {
    CardBody,
    CardHeader,
    CardBox,
    BtnMain,
    BtngroupSingle,
    ListItem,
    ListGroup,
    NoticeBody,
    NoticeHeader,
    NoticeBox,
    HeadingOne,
  },
  setup() {
    setMeta({
      title: "審査結果のご確認",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,入会,審査,審査結果",
    });
  },
  data() {
    return {
      state: this.$route.query.state,
      userData: {
        request_for_income_certificate: "", // 収入証明書要否
        revenue_certificate: "", // 収入証明書
        identification_document: "", // 本人確認書類
      },
    };
  },
  mounted() {
    try {
      getUserDataLambdaInvoke()
        .then((res) => {
          for (let key in res) {
            if (Object.prototype.hasOwnProperty.call(this.userData, key)) {
              this.userData[key] = res[key];
            }
          }
        })
        .catch((error) => {
          goToErrorPage(error);
        });
    } catch (e) {
      goToErrorPage(e);
    }
  },
};
</script>

<style scoped></style>
